import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Search, Menu, X, LayoutDashboard, LogOut, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/wei/Badges";
import { useAuth } from "@/context/AuthContext";
import { NAV } from "@/lib/helpers";

export function Header() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header data-testid="site-header" className="sticky top-0 z-40 bg-white/95 backdrop-blur-sm border-b border-[#E6E3DC]">
      <div className="container-wei h-[72px] flex items-center justify-between gap-6">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2.5">
          <button data-testid="header-search-btn" onClick={() => nav("/registry?focus=1")} className="p-2 text-ink hover:text-bordeaux transition-colors" aria-label="Search"><Search className="w-5 h-5" /></button>
          {user ? (
            <>
              <Link to={["admin", "reviewer"].includes(user.role) ? "/admin" : "/dashboard"} data-testid={["admin", "reviewer"].includes(user.role) ? "header-admin-link" : "header-dashboard-link"} className="hidden sm:inline-flex btn-ghost btn-sm items-center gap-1.5">
                {["admin", "reviewer"].includes(user.role) ? <ShieldCheck className="w-3.5 h-3.5 text-gold" /> : <LayoutDashboard className="w-3.5 h-3.5" />} {user.role === "admin" ? "Admin" : user.role === "reviewer" ? "Review" : "Dashboard"}
              </Link>
              <button data-testid="header-signout-btn" onClick={async () => { await logout(); nav("/"); }} className="hidden sm:inline-flex btn-bordeaux btn-sm items-center gap-1.5"><LogOut className="w-3.5 h-3.5" /> Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/signin" data-testid="header-signin-btn" className="hidden sm:inline-flex btn-ghost btn-sm">Sign In</Link>
              <Link to="/join" data-testid="header-join-btn" className="hidden sm:inline-flex btn-bordeaux btn-sm">Join WEI</Link>
            </>
          )}
          <button data-testid="mobile-menu-btn" className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu">{open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}</button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[#E6E3DC] bg-white">
          <nav className="container-wei py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)} className={({ isActive }) => `px-2 py-2.5 text-sm font-medium border-l-2 ${isActive ? "border-bordeaux text-ink" : "border-transparent text-charcoal"}`}>{n.label}</NavLink>
            ))}
            <div className="flex gap-2 pt-3">
              {user ? (
                <>
                  <Link to={["admin", "reviewer"].includes(user.role) ? "/admin" : "/dashboard"} onClick={() => setOpen(false)} className="btn-ghost btn-sm flex-1">{user.role === "admin" ? "Admin" : user.role === "reviewer" ? "Review" : "Dashboard"}</Link>
                  <button onClick={async () => { await logout(); setOpen(false); nav("/"); }} className="btn-bordeaux btn-sm flex-1">Sign Out</button>
                </>
              ) : (
                <>
                  <Link to="/signin" onClick={() => setOpen(false)} className="btn-ghost btn-sm flex-1">Sign In</Link>
                  <Link to="/join" onClick={() => setOpen(false)} className="btn-bordeaux btn-sm flex-1">Join WEI</Link>
                </>
              )}
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
